import { required } from "@src/utils/forms/validators";
import { FieldState, FormState } from "formstate";

export class FormCreditAccount {
  brand_id = new FieldState("").validators(required);
  team_id = new FieldState("").validators(required);
  title = new FieldState("").validators(required);
  budget_category_ids = new FieldState<string[]>([]).validators();

  form = new FormState({
    brand_id: this.brand_id,
    team_id: this.team_id,
    title: this.title,
    budget_category_ids: this.budget_category_ids,
  });

  validate = async () => {
    const res = await this.form.validate();

    return res.hasError
      ? null
      : {
          brand_id: this.form.$.brand_id.$,
          team_id: this.form.$.team_id.$,
          title: this.form.$.title.$,
          budget_category_ids: this.form.$.budget_category_ids.$,
        };
  };
}
